import React, { useState, useEffect } from 'react'
import { Modal, Form, Input, Select, Button, message } from 'antd'
import { api } from '../../../services/index.js'

const { Option } = Select

const EditGroupModal = ({
    visible,
    onCancel,
    onSuccess,
    group,
    locationId,
    users,
    userId
}) => {
    const [isUpdating, setIsUpdating] = useState(false)
    const [formData, setFormData] = useState({
        group_name: '',
        user_ids: []
    })

    useEffect(() => {
        if (group) {
            setFormData({
                group_name: group.group_name || '',
                user_ids: group.users?.map(u => Number(u.user_id || u.id)) || []
            })
        }
    }, [group])

    const handleUserChange = async (value) => {
        const prevIds = formData.user_ids || []
        if (value.length > 5 && value.length > prevIds.length) {
            message.warning('You can select a maximum of 5 users')
            return
        }
        const nextIds = value.map(Number)

        const removed = prevIds.filter(id => !nextIds.includes(id))

        for (const userId of removed) {
            try {
                await api.quest.removeUserFromGroup(locationId, group.group_id, userId)
            } catch (error) {
                console.error('Error removing user:', error)
                message.error('Failed to remove user')
            }
        }

        setFormData({ ...formData, user_ids: nextIds })
    }

    const handleUpdate = async () => {
        if (!formData.group_name) {
            message.error('Please input group name')
            return
        }
        if (!formData.user_ids.length) {
            message.error('Please select at least one user')
            return
        }

        setIsUpdating(true)
        try {
            const payload = {
                group_name: formData.group_name,
                user_ids: formData.user_ids.map(String),
                assigned_by: String(userId)
            }
            const res = await api.quest.updateLocationGroup(locationId, group.group_id, payload)
            if (res?.data) {
                message.success('Group updated successfully')
                if (onSuccess) {
                    onSuccess(res.data)
                }
            }
        } catch (error) {
            console.error('Error updating group:', error)
            message.error('Failed to update group')
        } finally {
            setIsUpdating(false)
        }
    }

    return (
        <Modal
            title="Edit Group"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" shape="round" type="default" style={{ borderRadius: '50px' }} disabled={isUpdating} onClick={onCancel}>
                    Cancel
                </Button>,
                <Button
                    style={{ borderRadius: '50px' }}
                    shape="round"
                    key="update"
                    type="primary"
                    loading={isUpdating}
                    onClick={handleUpdate}
                >
                    Update
                </Button>
            ]}
            centered
        >
            <Form layout="vertical">
                <Form.Item label="Group Name" required>
                    <Input
                        placeholder="e.g. Group A"
                        value={formData.group_name}
                        onChange={(e) => setFormData({ ...formData, group_name: e.target.value })}
                    />
                </Form.Item>
                <Form.Item label="Select Users" required>
                    <Select
                        mode="multiple"
                        placeholder="Select Users"
                        value={formData.user_ids}
                        onChange={handleUserChange}
                        showSearch
                        filterOption={(input, option) => {
                            const nameMatch = option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            const emailMatch = (option.props['data-email'] || '').toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            return nameMatch || emailMatch;
                        }}
                    >
                        {users.map(user => (
                            <Option key={user.user_id} value={Number(user.user_id)} data-email={user.user?.email}>
                                {`${user.user?.first_name} ${user.user?.last_name}`}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default EditGroupModal
